import type { EntityCtx } from '@cli-types/next-adapter/generators.js'
import { renderGenGetVersionsContentServerActionTemplate } from '@next-adapter/templates/renderers/generators/actions/entity-file-contents/gen-get-versions-content.js'

export function genGetVersionsContent(ctx: EntityCtx): string {
  return renderGenGetVersionsContentServerActionTemplate({
    ctxSingular: ctx.Singular,
    ctxPlural: ctx.plural
  })
}
